export interface IFilterProps {
  formProps: string;
  onSubmitProps: Function;
  formValues: any;
  messages: any;
  resetForm: Function;
  changeForm: (field: string, value: any) => {};
  listsFilter?: any;
  showHideFilter: Function;
}

export const TOGGLE_FIELD = "ToggleField";
export const DATA_RANGE_PICKER = "DateRangePicker";
export const SELECT_FIELD = "SelectFieldUI";
